import { usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import useIntroTooltip from "@custom-hooks/useIntroTooltip";
import { FlowManager } from "@uikit/flow/FlowManager";

export function useFitCanvas() {
  const flowManager = FlowManager.use();

  const {
    nodesState: { nodesRef },
  } = useHomeUsePluginContainer();

  const { showPreviewPanel } = usePreviewAppStore();
  const firstNode = nodesRef.current[0];
  const isAiChatOfNode = firstNode?.data?.chatAi || firstNode?.data?.showChatInterfaceTooltip;
  const { introTooltipObj } = useIntroTooltip(
    firstNode?.id,
    firstNode?.data?.displayType,
    undefined,
    undefined,
    isAiChatOfNode
  );

  /**
   * 1. 当节点过多时使用原来逻辑
   * 2. 当节点多少时(只有一条边,或一个节点) 执行100% focus 操作,但是需要在可执行的区域内
   */
  const fitCanvas = (duration = 200) => {
    flowManager.autoFit({
      duration,
      showPreviewPanel,
      showIntroTooltipObj: introTooltipObj.show,
    });
  };
  return { fitCanvas };
}
